<div class="mainProd">
    <div class="contain">
        <h2 class="bTit text-lg-start">Product</h2>
        <div class="category-list">
            <ul class="d-flex justify-content-lg-start justify-content-center">
                <!-- <li class="sub-category" (click) = "clickItemCate('All')" [ngClass]="active ==  'All' ? 'active' : ''">All</li> -->
                <ng-container *ngFor="let item of cates">
                  <ng-container *ngIf="this.chkMemEdu == 'N'">
                    <li *ngIf="item.cateCd != '0115'" class="sub-category" (click) = "clickItemCate(item.cateCd)"  [ngClass]="active == item.cateCd ? 'active' : ''">{{item.cateName}}</li>
                  </ng-container>
                  <ng-container *ngIf="this.chkMemEdu == 'Y'">
                    <li class="sub-category" (click) = "clickItemCate(item.cateCd)"  [ngClass]="active == item.cateCd ? 'active' : ''">{{item.cateName}}</li>
                  </ng-container>
                </ng-container>
            </ul>
        </div>
        <product-list  [cateCd] = "active" class="wdCate"></product-list>
    </div>
</div>
